import React from "react";
import {
  Accordion,
  ContentWithImage,
  Headline,
  Link,
  LinkPrimary,
  SectionContent,
  Text,
} from "../../../../components";
import DuvidasFrequentesImg from "../../../../assets/images/habitacional/ilustracao-mulher-apresentando-duvidas-frequentes.svg";
import { links } from "../../../../config";

const duvidasFrequentesList = [
  {
    title: "Quero entender mais sobre o meu seguro",
    body: (
      <Text>
        Criamos uma cartilha bem explicativa para te ajudar a entender mais
        sobre o seu seguro.{" "}
        <LinkPrimary
          target="_blank"
          href={links.habitacional.cartilhaSeguroHabitacional}
        >
          Baixe aqui
        </LinkPrimary>
        .
      </Text>
    ),
  },
  {
    title: "Como acionar o meu seguro?",
    body: (
      <>
        <Text>
          Caso aconteça algum imprevisto descrito no seu contrato, dependendo de
          qual seja, exigirá um procedimento particular e documentação
          específica. Temos um prazo de 30 dias para analisar o caso.
        </Text>
        <Text>
          1- Para cada caso há uma lista de documentos que deverá ser
          providenciada. Verifique no seu contrato de seguro, disponível na{" "}
          <LinkPrimary target="_blank" href={links.habitacional.areaLogada}>
            área do cliente
          </LinkPrimary>
          ;
        </Text>
        <Text>
          2- Entre em contato com a nossa Assistência Dia & Noite e Sinistros{" "}
          <LinkPrimary href="tel:08002741000">0800 274 1000</LinkPrimary>, opção
          3. O atendimento está disponível das 08h às 21h, de segunda a sexta.
        </Text>
        <Text>
          3- Caso necessário, nós poderemos solicitar documentos complementares.
        </Text>
      </>
    ),
  },
  {
    title: "Como acionar a Assistência Domiciliar 24h?",
    body: (
      <Text>
        Entre em contato com Assistência Dia & Noite e Sinistros{" "}
        <LinkPrimary href="tel:08002741000">0800 274 1000</LinkPrimary>, opção
        2. Este serviço está a sua disposição 24 horas por dia.
      </Text>
    ),
  },
  {
    title: "Quero saber mais sobre o meu financiamento",
    body: (
      <Text>
        Para informações sobre o seu Financiamento Habitacional Caixa, acesse o{" "}
        <LinkPrimary target="_blank" href={links.habitacional.internetBanking}>
          Internet Banking Caixa
        </LinkPrimary>
        .
      </Text>
    ),
  },
  {
    title: "Posso alterar a forma de pagamento?",
    body: (
      <Text>
        Sim. Você pode optar por débito em conta Caixa ou pagamento em boleto. O
        seu seguro é cobrado junto com a parcela do seu financiamento e para
        fazer a alteração você precisa procurar uma agência Caixa.
      </Text>
    ),
  },
  {
    title: "Posso cancelar o meu seguro?",
    body: (
      <>
        <Text>
          Como o seu seguro acompanha o seu financiamento imobiliário, ele não
          pode ser cancelado. Assim, o saldo devedor pode ser quitado ou
          amortizado, possibilitando que você e sua família permaneçam com o
          imóvel em caso de morte ou invalidez permanente. Além disso, ele
          garante a indenização de danos físicos ao seu imóvel, como
          desmonoramento, incêndio, raio, vendaval, entre outros.
        </Text>
        <Text>
          Quando seu financiamento é quitado, ele é automaticamente encerrado.
        </Text>
      </>
    ),
  },
  {
    title: "O que o seguro habitacional não cobre?",
    body: (
      <Text>
        O seguro serve pra não te deixar no aperto. Se algo acontecer, nós
        daremos o suporte financeiro para reparar os prejuízos. Porém, a má
        conservação do imóvel, infiltrações e rachaduras não possuem coberturas,
        assim como os eventos que ocorrem por falha na construção ou por não
        atender as normas básicas instituidas pela{" "}
        <Link target="_blank" href={links.habitacional.abnt}>
          Associação Brasileira de Normas Técnicas - ABNT
        </Link>
        .
      </Text>
    ),
  },
  {
    title:
      "Entenda como são as comissões de venda e as participações societárias dos intermediários para o Seguro Habitacional",
    body: (
      <>
        <Text>
          Nos termos da Resolução CNSP nº 382/2020, a Caixa Seguradora S.A.
          informa que a CAIXA, por meio de sua subsidiária integral Caixa
          Seguridade Participações S.A., detém participação societária direta
          sobre a Caixa Seguros HoldingS.A., no percentual de 48,21% e, indireta
          sobre a Wiz Soluções e Corretagem de Seguros S.A., no percentual de
          12,05%.
        </Text>
        <Text>
          Informamos ainda que a Caixa Seguros Holding S.A. detém participação
          societária direta sobre a Wiz Soluções e Corretagem de Seguros S.A.,
          com percentual de 25%. A Caixa Seguros Holding – CSH remunera seus
          intermediários em até 9%, mediante pagamento de Tarifa Balcão,
          remuneração paga ao agente financeiro para o estímulo à indicação do
          Seguro Habitacional no seu balcão de vendas, no percentual de 5% e de
          Comissão paga à Corretora pela comercialização do seu Seguro
          Habitacional, no percentual de até 4%.
        </Text>
      </>
    ),
  },
];

const SaibaMais = () => {
  return (
    <>
      <SectionContent>
        <ContentWithImage
          imgSrc={DuvidasFrequentesImg}
          imgAlt="Mulher apresentando as dúvidas frequentes"
          imgColumnSize="6"
        >
          <Headline as="2" styleAs="4">
            Saiba mais sobre o seu seguro
          </Headline>
          <Accordion listItems={duvidasFrequentesList} />
        </ContentWithImage>
      </SectionContent>
    </>
  );
};

export default SaibaMais;
